// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"9e4d2d59","703":"9874a436"}[chunkId] + ".chunk.js";
};